// GeoJSON data for field boundaries
import { generateDMVFieldBoundaries } from '../utils/croplandCrosAPI';

// Generate DMV-specific field boundaries
export const fieldBoundaries = generateDMVFieldBoundaries();

// The original data is kept as a reference but not used
export const originalFieldBoundaries = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        name: "Area 1",
        health: 95,
        status: "good",
        area: 120,
        crop: "Wheat",
        plantDate: "2023-03-15"
      },
      geometry: {
        type: "Polygon",
        coordinates: [[
          [12.5, 41.9],
          [12.52, 41.91],
          [12.53, 41.89],
          [12.51, 41.88],
          [12.49, 41.89],
          [12.5, 41.9]
        ]]
      }
    },
    {
      type: "Feature",
      properties: {
        name: "Area 2",
        health: 84,
        status: "warning",
        area: 95,
        crop: "Corn",
        plantDate: "2023-04-02"
      },
      geometry: {
        type: "Polygon",
        coordinates: [[
          [12.51, 41.87],
          [12.53, 41.86],
          [12.54, 41.85],
          [12.52, 41.84],
          [12.5, 41.85],
          [12.51, 41.87]
        ]]
      }
    },
    {
      type: "Feature",
      properties: {
        name: "Irrigation Pond",
        type: "water",
        capacity: "250000 gallons"
      },
      geometry: {
        type: "Point",
        coordinates: [12.52, 41.855]
      }
    }
  ]
}; 